import type { Action, BoundActions, HookActionsFunction, HookFunction } from 'react-sweet-state';
import { createHook, createStore, createActionsHook } from 'react-sweet-state';
interface DialogState {
	isOpen: boolean;
	touchpointId?: string;
}

const initialState: DialogState = { isOpen: false };
const actions = {
	showModal:
		({ touchpointId }: { touchpointId: any }): Action<DialogState> =>
		({ setState }) => {
			setState({ isOpen: true, touchpointId });
		},
	closeModal:
		(): Action<DialogState> =>
		({ setState }) => {
			setState({ isOpen: false });
		},
};

const store = createStore({
	initialState,
	actions,
	name: 'trialPlanComparisonModalStore',
});

export const useTrialPlanComparisonModalActions: HookActionsFunction<
	BoundActions<
		DialogState,
		{
			showModal: ({ touchpointId }: { touchpointId: any }) => Action<DialogState>;
			closeModal: () => Action<DialogState>;
		}
	>
> = createActionsHook(store);

export const useTrialPlanComparisonModal: HookFunction<
	DialogState,
	BoundActions<
		DialogState,
		{
			showModal: ({ touchpointId }: { touchpointId: any }) => Action<DialogState>;
			closeModal: () => Action<DialogState>;
		}
	>,
	void
> = createHook(store);
